import L from 'leaflet';

/**
 * Return the distance, in meters, of the smaller dimension (height or width) of
 * the visible extent of the map accounting for any supplied padding
 *
 * @param {L.Map} map
 * @param {Object} [padding] Similar to options accepted to by
 * `map.fitBounds`; pass `paddingTopLeft` and/or `paddingBottomRight` keys
 * to modify the map extent of the map used in this calculation
 */
export const getMapBoundsExtent = (
  map,
  padding = { paddingTopLeft: [0, 0], paddingBottomRight: [0, 0] }
) => {
  const minBounds = L.point(padding.paddingTopLeft || [0, 0]);
  const maxBounds = map
    .getSize()
    .subtract(L.point(padding.paddingBottomRight || [0, 0]));
  const boundsWidth = maxBounds.x - minBounds.x;
  const boundsHeight = maxBounds.y - minBounds.y;
  let endPoint;

  if (boundsWidth < boundsHeight) {
    endPoint = map.containerPointToLatLng([maxBounds.x, minBounds.y]);
  } else {
    endPoint = map.containerPointToLatLng([maxBounds.y, minBounds.x]);
  }

  return map.containerPointToLatLng(minBounds).distanceTo(endPoint);
};

/**
 * Pan the map to the supplied coordinates adjusted from the center of the map
 * by the supplied offset
 *
 * @param {L.Map} map
 * @param {L.LatLng} latLng Coordinates to which offset will be applied,
 * accepts all formats allowed by the map's `panTo` method
 * @param {Array} offset X and Y values, in pixels, for which the point will be
 * offset from the center of the screen
 * @param {Object} [panOptions] Pan options accepted by the map's `panTo` method
 */
export const panToWithOffset = (map, latLng, offset, panOptions = {}) => {
  const { x, y } = map.latLngToContainerPoint(latLng);

  return map.panTo(
    map.containerPointToLatLng([x - offset[0], y - offset[1]]),
    panOptions
  );
};
